export const bdeListSchema = {
	schema: {
		title: 'bde list schema',
		description: 'BDE List Schema',
		version: 0,
		primaryKey: 'id',
		type: 'object',
		properties: {
			id: {
				type: 'string',
				maxLength: 250,
			},
			sfid: {
				type: 'string',
			},
			mdicode_c: {
				type: 'string',
			},
		},
		required: ['id', 'sfid', 'mdicode_c'],
	},
};
